import * as React from 'react';
import { CellSummaryDetails } from './CellSummaryDetails';
export const CellSummaryPopover = (props) => {
    return React.createElement(CellSummaryDetails, { CellSummary: props.CellSummary });
};
